{
  "actions": "Действия",
  "hideButtonLabel": "Показване на по-малко",
  "noTags": "Нито един",
  "showAllButtonLabel": "Показване на всички ({tagCount, number})"
}
